/**
 * FormValidation (https://formvalidation.io)
 * The best validation library for JavaScript
 * (c) 2013 - 2018 Nguyen Huu Phuoc <me@phuoc.ng>
 */

import formValidation from './Core';
import Plugin from './Plugin';
import Status from './Status';

export default formValidation;
export {
    Plugin,
    Status,
};
